import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IcsDownloadService {

  constructor() { }

  /**
   * Triggers download of an .ics file for a calendar event.
   * @param options Event details
   */
  downloadEvent(options: {
    uid?: string;
    start: Date;
    end: Date;
    summary: string;
    description?: string;
    location?: string;
    filename?: string;
  }) {
    const {
      uid,
      start,
      end,
      summary,
      description = '',
      location = '',
      filename = 'event.ics'
    } = options;

    const dtstamp = this.formatDateICS(new Date());
    const dtstart = this.formatDateICS(start);
    const dtend = this.formatDateICS(end);

    const icsContent =
      'BEGIN:VCALENDAR\r\n' +
      'VERSION:2.0\r\n' +
      'PRODID:-//Tarento//Kronos//EN\r\n' +
      'BEGIN:VEVENT\r\n' +
      `UID:${uid}\r\n` +
      `DTSTAMP:${dtstamp}\r\n` +
      `DTSTART:${dtstart}\r\n` +
      `DTEND:${dtend}\r\n` +
      `SUMMARY:${summary}\r\n` +
      `DESCRIPTION:${description}\r\n` +
      `LOCATION:${location}\r\n` +
      `BEGIN:VALARM\r\n` +
      `ACTION:DISPLAY\r\n` +
      `DESCRIPTION:${description}\r\n` +
      `TRIGGER:-PT15M\r\n` +
      `END:VALARM\r\n` +
      'END:VEVENT\r\n' +
      'END:VCALENDAR';

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(url);
  }

  /**
   * Helper to format date as YYYYMMDDTHHmmssZ (UTC)
   */
  private formatDateICS(date: Date): string {
    const pad = (n: number) => n < 10 ? '0' + n : n;
    return date.getUTCFullYear().toString() +
      pad(date.getUTCMonth() + 1) +
      pad(date.getUTCDate()) + 'T' +
      pad(date.getUTCHours()) +
      pad(date.getUTCMinutes()) +
      pad(date.getUTCSeconds()) + 'Z';
  }
}
